import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const { height = 24, width = 24, fill = "currentColor" } = props
    const strokeColor = fill || "currentColor"
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33301 3.33301H8.33301V8.33301H3.33301V3.33301Z" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.667 3.33301H16.667V8.33301H11.667V3.33301Z" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.33301 11.667H8.33301V16.667H3.33301V11.667Z" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.667 14.167C11.667 14.83 11.9304 15.4659 12.3992 15.9348C12.8681 16.4036 13.504 16.667 14.167 16.667C14.83 16.667 15.4659 16.4036 15.9348 15.9348C16.4036 15.4659 16.667 14.83 16.667 14.167C16.667 13.504 16.4036 12.8681 15.9348 12.3992C15.4659 11.9304 14.83 11.667 14.167 11.667C13.504 11.667 12.8681 11.9304 12.3992 12.3992C11.9304 12.8681 11.667 13.504 11.667 14.167Z" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>


    )
}

export default SvgComponent
